((document, window, history) => {
	const pushState = history.pushState;

	function hubspotLightbox() {
			var btn = document.querySelector('.hubspot-lightbox');
			var modal = document.querySelector('.modal');
			var closeBtn = document.querySelector('.close-btn');
		
			btn.addEventListener('click', function(event) {
				event.preventDefault();
				modal.style.display = 'flex';
				document.querySelector('body').classList.add('lightbox');
			});
		
			closeBtn.addEventListener('click', function() {
				modal.style.display = 'none';
				document.querySelector('body').classList.remove('lightbox');
			});
	}

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	// default navigation subnav
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}

	function farloUiMcSignup(_sel) {
		let farloUiSignupForm = null;

		if (farloUiSignupForm) {
			farloUiSignupForm.toggleForm();
		} else {
			farloUiSignupForm = new FarloUiMc(_sel.id);
		}
	}

	function gsapFadeText(_sel) {
		gsap.fromTo(_sel.querySelectorAll('.site-text--animate'), {
			'will-change': 'opacity',
			opacity: 0.3
		}, {
			ease: 'none',
			opacity: 1,
			stagger: .05,
			scrollTrigger: {
				trigger: _sel,
				start: 'top bottom-=20%',
				end: 'center top+=20%',
				scrub: !0
			}
		});
	}

	function mastheadAnimation(){
	
			gsap.from('.site-masthead .site-logo', {
				opacity: 0,
				scale:0,
				duration: 1
			});

			gsap.from('.site-masthead__credits', {
				opacity: 0,
				scale:0,
				duration: 1,
				delay:0.5
			});

			gsap.from('.site-masthead__location-info', {
				opacity: 0,
				scale:0,
				duration: 1,
				delay:0.75
			});

			gsap.from('.site-masthead__inner-image picture', {
				opacity: 0,
				x:-250,
				duration: 1,
				delay:0
			});

			gsap.from('.site-masthead__cast-members ', {
				opacity: 0,
				scale:0,
				duration: 1,
				delay:1
			});
		
	}

	function farloUiLightbox(elem, div) {
		if (elem.querySelector('.wp-block-image')) {
			elem.querySelectorAll('.wp-block-image').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					const clonedEmbed = e.currentTarget.cloneNode(true);
					document.body.classList.add('body--farlo-ui-lightbox-open');
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '';
					clonedEmbed.removeAttribute('style');
					div.querySelector('.site-farlo-ui-lightbox__inner-content').appendChild(clonedEmbed);
					div.classList.add('site-farlo-ui-lightbox--active');
				});
			});
		}

		if ((elem.nextElementSibling && elem.nextElementSibling.value) || (elem.querySelector('.site-farlo-ui-lightbox__html') && elem.querySelector('.site-farlo-ui-lightbox__html').value)) {
			elem.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.site-farlo-ui-lightbox__inner-content').classList.add('dynamic');

				if ((e.currentTarget.nextElementSibling && e.currentTarget.nextElementSibling.value)) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.nextElementSibling.value;
				} else if (e.currentTarget.querySelector('.site-farlo-ui-lightbox__html') && e.currentTarget.querySelector('.site-farlo-ui-lightbox__html').value) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = e.currentTarget.querySelector('.site-farlo-ui-lightbox__html').value;
				}
				div.classList.add('site-farlo-ui-lightbox--active');
			});
		}

		if (elem.querySelector('a[href*="youtu.be"]')) {
			elem.querySelector('a[href*="youtu.be"]').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.add('body--farlo-ui-lightbox-open');
				div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '<iframe class="site-farlo-ui-lightbox__inner-content-iframe" src="https://www.youtube-nocookie.com/embed/' + e.target.href.match(youTubeRegex)[ 1 ] + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
				div.classList.add('site-farlo-ui-lightbox--active');
			});
		}

		if (div.querySelector('.site-farlo-ui-lightbox__button-close')) {
			div.querySelector('.site-farlo-ui-lightbox__button-close').addEventListener('click', function(e) {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				e.currentTarget.closest('.site-farlo-ui-lightbox').classList.remove('site-farlo-ui-lightbox--active');
				if (div.querySelector('.site-farlo-ui-lightbox__inner-content.dynamic')) {
					div.querySelector('.site-farlo-ui-lightbox__inner-content').classList.remove('dynamic');
				}
				div.querySelector('.site-farlo-ui-lightbox__inner-content').innerHTML = '';

				if (elem.classList.contains('site-geo-targeting')) {
					window._farlo.storage.set('geotargeted', 'true', 'cookie');
				}
			});
		}
	}

	if(document.querySelector('.site-masthead')){
		mastheadAnimation();
	}

	function gsapMarquee(_sel) {
		// set a default rate, the higher the value, the faster it is
		const rate = 100;
		// get the width of the element
		const distance = _sel.clientWidth;
		// get the margin-right of the element
		const style = window.getComputedStyle(_sel);
		const marginRight = parseInt(style.marginRight) || 0;
		// get the total width of the element
		const totalDistance = distance + marginRight;
		// get the duration of the animation
		// for a better explanation, see the quoted codepen in the first comment
		const time = totalDistance / rate;
		// get the parent of the element
		const container = _sel.parentElement;

		container.appendChild(_sel.cloneNode(true));
		container.appendChild(_sel.cloneNode(true));
		container.appendChild(_sel.cloneNode(true));
		container.appendChild(_sel.cloneNode(true));

		gsap.to(container, time, {
			repeat: -1,
			x: '-' + totalDistance,
			ease: Linear.easeNone
		});
	}

	function headingScroller(_sel) {
		const scrollTop = window.scrollY;

		_sel.querySelector('h2').dataset.title = _sel.querySelector('h2').innerText;

		if (scrollTop === (_sel.getBoundingClientRect().top - document.querySelector('#about').getBoundingClientRect().height)) {
			_sel.style.WebkitTransform = 'translateX(-85%)';
			_sel.style.msTransform = 'translateX(-85%)';
			_sel.style.transform = 'translateX(-85%)';
		} else {
			_sel.style.WebkitTransform = 'translateX(' + parseInt(100 - ((scrollTop / window.innerHeight) * 300)) + '%' + ')';
			_sel.style.msTransform = 'translateX(' + parseInt(100 - ((scrollTop / window.innerHeight) * 300)) + '%' + ')';
			_sel.style.transform = 'translateX(' + parseInt(100 - ((scrollTop / window.innerHeight) * 300)) + '%' + ')';
		}
	}

	function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			e.preventDefault();

			if (document.body.classList.contains('site-navigation__nav--open')) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.href.includes('#') && window.location.href.split('/')[3] === '') {
				document.getElementById(e.target.href.split('#')[ 1 ]).scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location = e.target.href;
			}
		});
	}

	function carousels() {
		document.querySelectorAll('.revolver-carousel').forEach((_sel) => {
			if (_sel.children.length > 1) {
				const config = {
					cellAlign: 'center',
					wrapAround: true,
					draggable: true,
					pageDots: false,
					prevNextButtons: false,
					autoPlay: 4000,
					lazyLoad: true,
					setGallerySize: false
				};

				const carousel = new Flickity(_sel, config);
				const cellsButtonGroup = _sel.parentNode.querySelector('.revolver-carousel__nav-pager');

				if (cellsButtonGroup) {
					const utils = window.fizzyUIUtils;
					const cellsButtons = utils.makeArray(cellsButtonGroup.children);

					// update buttons on select
					carousel.on('select', function() {
						const previousSelectedButton = cellsButtonGroup.querySelector('.is-selected');
						const selectedButton = cellsButtonGroup.children[ carousel.selectedIndex ];
						previousSelectedButton.classList.remove('is-selected');
						selectedButton.classList.add('is-selected');
					});

					// cell select
					cellsButtonGroup.addEventListener('click', function(event) {
						if (!matchesSelector(event.target, '.revolver-carousel__nav-pager-button')) {
							return;
						}
						const index = cellsButtons.indexOf(event.target);
						carousel.select(index);
					});
				}

				// previous
				const previousButton = _sel.parentNode.querySelector('.revolver-carousel__nav-buttons-button--prev');

				if (previousButton) {
					previousButton.addEventListener('click', function() {
						carousel.previous();
					});
				}

				// next
				const nextButton = _sel.parentNode.querySelector('.revolver-carousel__nav-buttons-button--next');

				if (nextButton) {
					nextButton.addEventListener('click', function() {
						carousel.next();
					});
				}
			}
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {

		if(document.querySelector('.hubspot-form')){
			hubspotLightbox();
		}
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		const lightboxEmbed = document.querySelectorAll('.site-video-embed-group, .site-farlo-ui-lightbox__toggle, .wp-block-gallery:not(.revolver-carousel)');
		let div;
		let divInner;
		let divInnerContent;
		let divClose;
		
		if (lightboxEmbed.length > 0) {
			div = document.createElement('div');
			divInner = document.createElement('div');
			divInnerContent = document.createElement('div');
			divClose = document.createElement('button');
			div.className = 'site-farlo-ui-lightbox';
			divInner.className = 'site-farlo-ui-lightbox__inner';
			divInnerContent.className = 'site-farlo-ui-lightbox__inner-content';
			divClose.className = 'site-farlo-ui-lightbox__button-close';

			document.body.appendChild(div);
			document.querySelector('.site-farlo-ui-lightbox').appendChild(divInner);
			document.querySelector('.site-farlo-ui-lightbox__inner').appendChild(divInnerContent);
			document.querySelector('.site-farlo-ui-lightbox__inner').appendChild(divClose);

			lightboxEmbed.forEach(function(elem) {
				farloUiLightbox(elem, div);
			});
		}

		if (document.querySelector('.site-text--fade-in')) {
			document.querySelectorAll('.site-text--fade-in').forEach((_sel) => {
				const joined = [];
				_sel.querySelectorAll('p').forEach((_p) => {
					const _spans = _p.innerHTML.split(' ');
					for (let i = 0; i < _spans.length; i ++) {
						_spans[ i ] = "<span class='site-text--animate dark'>" + _spans[ i ] + '</span>';
					}
					joined.push('<p>' + _spans.join(' ') + '</p>');
				});
				_sel.innerHTML = joined.join(' ');
			});
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-text--scroll')) {
			document.querySelectorAll('.site-text--scroll').forEach((_sel) => {
				headingScroller(_sel);
			});
		}

		if (document.querySelector('.revolver-carousel')) {
			carousels();
		}

		document.querySelectorAll('.site-marquee__scroll-text').forEach((_sel) => {
			gsapMarquee(_sel);
		});

		if (document.querySelector('.site-farlo-ui-crm')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiMcSignup(_sel);
			});

			document.querySelectorAll('.site-farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					farloUiMcSignup(document.querySelector('#' + e.currentTarget.dataset.crmButtonFor));
				});
			});
		}
	

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar();
			});
		}
	});

	window.addEventListener('scroll', () => {
		document.querySelectorAll('.site-text--scroll').forEach((_sel) => {
			headingScroller(_sel);
		});
	});

	window.addEventListener('resize', () => {
		if (document.querySelector('.site-text--fade-in')) {
			document.querySelectorAll('.site-text--fade-in').forEach((_sel) => {
				gsapFadeText(_sel);
			});
		}
	});

	window.addEventListener('load', () => {


		if (document.querySelector('.site-text--fade-in')) {
			if (typeof gsap !== 'undefined') {
				gsap.registerPlugin(ScrollTrigger);
			}
			document.querySelectorAll('.site-text--fade-in').forEach((_sel) => {
				gsapFadeText(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				_sel.farloUiRevolverCarousel();
			});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
	
})(document, window, history);
